import {useEffect, useState} from 'react'
import {Flex, Text, Box, Center, useToast} from '@chakra-ui/react'
import {Button, Form} from 'antd'
import {CommonColors} from '@utils/CommonStyles'
import {
  AUTH_ACTION,
  LOCAL_STORAGE,
  SCREEN_TRACKING,
  STATUS_CODE,
} from '@utils/Const'
import appRequest from '@apis/app'
import {trackingPage} from '@utils'
import OtpInput from '@pages/NonAuthentication/RegisterPage/components/OtpInput'

const Otp = ({
  user,
  setUser,
  setIsVerifyPassword,
  setIsTypePhone,
  handleBack,
  setIsLoading,
}: any) => {
  const toast = useToast()
  const [timeLeft, setTimeLeft] = useState(30)
  const [otp, setOtp] = useState('')

  useEffect(() => {
    trackingPage(SCREEN_TRACKING.OTP_PAGE)
  }, [])

  useEffect(() => {
    if (!timeLeft) {
      return
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1)
      if (timeLeft === 1) {
        clearInterval(intervalId)
      }
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const handleVerifyOtp = async () => {
    setIsLoading(true)
    const res = await appRequest.verifyOTP({
      ...user,
      otp: otp,
      action: AUTH_ACTION.FORGET_PASSWORD,
    })
    if (res?.data?.status === STATUS_CODE.SUCCESS) {
      setUser({...user, token: res?.data?.data?.token})
      setIsVerifyPassword(true)
      setIsTypePhone(true)
    } else {
      toast({
        title: res.response?.data?.message || 'Đã có lỗi xảy ra',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
    setIsLoading(false)
  }

  const resendOtp = async () => {
    setTimeLeft(30)
    await appRequest.resendOTP({...user, action: AUTH_ACTION.FORGET_PASSWORD})
  }

  return (
    <Box sx={styles.form}>
      <Flex flexDirection={'column'}>
        <Text sx={styles.title}>Xác thực số điện thoại</Text>
        <Form name="basic" layout={'vertical'} autoComplete="off">
          <Text sx={styles.textContent}>
            Điền mã OTP vừa được gửi đến số điện thoại{' '}
          </Text>
          <Text sx={styles.textPhone}>{user?.phone}</Text>
          <Center>
            <OtpInput onChange={(otp: string) => setOtp(otp)} />
          </Center>
          <Flex justifyContent={'space-between'} mb={4}>
            <a onClick={handleBack}>
              <Text sx={styles.textChangePhone}>Đổi số điện thoại</Text>
            </a>
            {timeLeft > 0 ? (
              <Flex alignItems={'center'}>
                <Text sx={styles.textResend}>Gửi lại OTP sau </Text>
                <Text sx={styles.textTime}>{`(${
                  ('0' + Math.floor(timeLeft / 60)).slice(-2) +
                  ':' +
                  ('0' + Math.floor(timeLeft % 60)).slice(-2)
                })`}</Text>
              </Flex>
            ) : (
              <a onClick={resendOtp}>
                <Text sx={styles.textChangePhone}>Gửi lại OTP</Text>
              </a>
            )}
          </Flex>
          <Form.Item>
            <Button
              type="primary"
              style={styles.button}
              disabled={otp?.length < 6}
              onClick={() => handleVerifyOtp()}>
              Xác nhận
            </Button>
          </Form.Item>
        </Form>
      </Flex>
    </Box>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    backgroundColor: CommonColors.blue1,
  },
  form: {
    flexDirection: 'column',
    backgroundColor: CommonColors.white,
    width: '480px',
    padding: 8,
    alignItems: 'center',
    borderRadius: '24px',
    justifyContent: 'center',
  },
  logo: {
    width: '400px',
    marginBottom: '48px',
  },
  button: {
    width: '100%',
    borderRadius: '12px',
    height: '46px',
  },
  textRegister: {
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'center',
  },
  textContent: {
    fontWeight: 500,
    fontSize: '16px',
    textAlign: 'center',
    color: CommonColors.shadow3,
  },
  textPhone: {
    fontWeight: 600,
    fontSize: '16px',
    textAlign: 'center',
    color: CommonColors.shadow4,
    marginBottom: '16px',
  },
  textChangePhone: {
    fontWeight: 700,
    fontSize: '16px',
    color: CommonColors.blue,
  },
  textResend: {
    fontWeight: 400,
    fontSize: '14px',
    color: CommonColors.shadow3,
  },
  textTime: {
    fontWeight: 700,
    fontSize: '16px',
    color: CommonColors.shadow,
    marginLeft: '4px',
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    textAlign: 'center',
    marginBottom: '16px',
  },
}

export default Otp
